import { render, staticRenderFns } from "./merchantsInformationEditDetail.vue?vue&type=template&id=da486e06&scoped=true&lang=pug&"
import script from "./merchantsInformationEditDetail.vue?vue&type=script&lang=js&"
export * from "./merchantsInformationEditDetail.vue?vue&type=script&lang=js&"
import style0 from "./merchantsInformationEditDetail.vue?vue&type=style&index=0&id=da486e06&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da486e06",
  null
  
)

export default component.exports